import styles from "./styles.module.scss";
import ArrowGreen from "../../../public/static-next/arrow-green.svg";

interface Title {
  children: string | JSX.Element;
  style?: React.CSSProperties;
}

export const TitleHighlight = ({ children, style = null }: Title) => {
  return (
    <div className={styles.groupTitle}>
      <ArrowGreen />
      <h2 style={style} className={styles.title}>
        {children}
      </h2>
    </div>
  );
};
